export default function Mute() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 32" fill="none">
        <title>Muted</title>
        <path
          d="M8.61328 10.0007H0.613281V22.0007H8.61328L18.6133 30.0007V2.00073L8.61328 10.0007ZM32.4133 11.2007L30.8133 9.80073L26.2133 14.6007L21.4133 9.80073L19.8133 11.2007L24.6133 16.0007L19.8133 20.8007L21.4133 22.2007L26.2133 17.4007L30.8133 22.2007L32.4133 20.8007L27.6133 16.0007L32.4133 11.2007Z"
          fill="#838383"
        />
      </svg>
    </>
  )
}
